import * as React from "react";
import { observer } from "mobx-react-lite";
import { Button, Input, Space } from "antd";
import { SaveOutlined } from "@ant-design/icons";
import { Mc2EntityStore } from "./Mc2EntityStore";

interface PropsMc2EntityComment {
  store: Mc2EntityStore;
}

export const Mc2EntityComment: React.FC<PropsMc2EntityComment> = observer(
  ({ store }) => {
    const { curComment, mcEntity } = store;
    const oldComment = mcEntity.comment ?? "";
    const save = () => store.updateEntity("comment", curComment);
    return (
      <Space.Compact style={{ width: "100%" }}>
        <Input
          value={curComment}
          disabled={store.readOnly}
          onChange={(e) => {
            store.setCurComment(e.currentTarget.value);
          }}
          onKeyUp={(e) => {
            if (e.code === "Escape") {
              store.setCurComment(oldComment);
            } else if (e.code === "Enter") {
              // Если заменить Input на TextArea, то этот обработчик надо убрать.
              save();
            }
          }}
        />
        {curComment !== oldComment && (
          <Button
            icon={<SaveOutlined />}
            type="primary"
            loading={store.taskType === "updateEntity"}
            onClick={save}
          />
        )}
      </Space.Compact>
    );
  },
);
